<template>
    <div class="linked-content-tools">
        <action
            name="link"
            class="print"
            with-icon="mdi-printer"
            :nochevron="true"
            :small="true"
            @click="printWindow()"
        >
            Imprimer
        </action>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    methods: {
        printWindow() {
            window.print();
        },
    },
});
</script>

<style lang="sass" scoped>
@media print
    .linked-content-tools
        display: none
</style>
